import _styled from "@emotion/styled/base";
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useWidth } from '../../../Utils';
import { SidebarContext } from './SidebarContext';
import { Sidebar } from './Sidebar';
import { Row } from '../FoundationLayouts';
import { Colors } from '../../../Foundation';
const useSidebarStrategy = () => {
  const width = useWidth();
  if (width === 'xs') return 'full-overlay';
  if (width === 'sm' || width === 'md') return 'partial-overlay';
  return 'side-by-side';
};
const PageContentScrollBox = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "ezlhhbd0"
} : {
  target: "ezlhhbd0",
  label: "PageContentScrollBox"
})("height:100%;overflow-y:auto;overflow-x:hidden;scrollbar-color:", Colors.new_grey_light, " transparent;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
export const PageWithSidebar = _ref => {
  let {
    pageContent,
    sidebarContent,
    pageName
  } = _ref;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarStrategy = useSidebarStrategy();
  const sidebarContext = useMemo(() => {
    return {
      isSidebarOpen,
      setIsSidebarOpen,
      sidebarStrategy
    };
  }, [isSidebarOpen, setIsSidebarOpen, sidebarStrategy]);
  return /*#__PURE__*/React.createElement(SidebarContext.Provider, {
    value: sidebarContext
  }, /*#__PURE__*/React.createElement(Row, {
    style: {
      gap: 0,
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(PageContentScrollBox, {
    style: {
      flexGrow: 1
    }
  }, pageContent), /*#__PURE__*/React.createElement(Sidebar, {
    closeButtonText: "Back to ".concat(pageName)
  }, sidebarContent)));
};
PageWithSidebar.propTypes = {
  pageContent: PropTypes.element.isRequired,
  sidebarContent: PropTypes.element.isRequired,
  pageName: PropTypes.string.isRequired
};